import React from 'react';
import PropTypes from 'prop-types';

/**
 * SkeletonTitle Component
 * 
 * A skeleton for loading titles and headers.
 * 
 * @param {Object} props
 * @param {string} props.size - Size variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'display' | 'metric'
 * @param {string} props.width - Width class or custom width
 * @param {string} props.className - Additional CSS classes
 * @component
 */
export default function SkeletonTitle({ 
  size = 'h3', 
  width = 'w-48', 
  className = '' 
}) {
  const sizeClasses = {
    display: 'h-12',  // For type-display
    metric: 'h-12',   // For large metrics/KPIs
    h1: 'h-10',       // For type-h1
    h2: 'h-8',        // For type-h2
    h3: 'h-7',        // For type-h3
    h4: 'h-6',        // For type-h4
    h5: 'h-6',        // For type-h5
    h6: 'h-5'         // For type-h6
  };

  return (
    <div
      className={`bg-gray-200 rounded animate-pulse ${sizeClasses[size]} ${width} ${className}`}
      aria-label="Loading title"
    />
  );
}

SkeletonTitle.propTypes = {
  size: PropTypes.oneOf(['display', 'metric', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  width: PropTypes.string,
  className: PropTypes.string,
};